import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from "react-redux";
import { withRouter } from 'react-router-dom';
import { PDFViewer, Document, Image, Page, View, Text, StyleSheet } from '@react-18-pdf/renderer';
import { useLocation } from "react-router-dom";
import { styled } from '@mui/material/styles';
import logoRaiar from '../../../img/raiar.png'
import moment from 'moment'
import { OBRA_DIARIO_CONDICAO_CLIMATICA } from '../../../utils';
import { ObraDiarioPrintPdfFooter } from './'

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    fontSize: 7,
    borderTop: 1,
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1
  },
  column: {
    flexDirection: 'column',
  },
  cellCabecalho: {
    padding: 6,
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    borderBottom: 1,
  },
  cellLastCabecalho: {
    padding: 6,
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  cellLastCabecalhoAlignLeft: {
    padding: 6,
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'left'
  },
  cellRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: 1,
  },
  cellLastRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  cellLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    width: '20%', // Ajuste a largura para que ocupe a parte da tabela adequadamente
    textAlign: 'left',
    padding: 5,
    borderRight: 1,
  },
  cellValue: {
    fontSize: 14,
    width: '80%', // Ajuste a largura do valor para preencher o espaço restante
    textAlign: 'left',
    paddingLeft: 6,
  },
  header: {
    textAlign: 'center',
    padding: 5,
  },
  backgroundImage: {
    justifyContent: 'center',
    width: '40%',
    objectFit: 'contain'
  },
  imageAnexo: {
    width: 190,
    height: 110,
    objectFit: 'contain'
  },
});

const CustomPage = styled(Page)(({ theme }) => ({
  padding: 20,
  paddingBottom: 25,
  height: '100%',
  width: '100%',
}));

const ObraDiarioPrintPdf = (props) => {
  const location = useLocation();

  const [ready, setReady] = useState(false);
  const { match: { params } } = props;
  const { obraDiario } = location.state || {};
  const equipes = obraDiario.obrasDiariosEquipes;
  const anexos = obraDiario.obrasDiariosAnexos;
  const [imageBase64, setImageBase64] = useState(null);
  const [anexosCarregadosPrint, setAnexosCarregadosPrint] = useState(null);
  const [anexosCarregados, setAnexosCarregados] = useState(false);
  const isImageUrl = (url) => /\.(jpeg|jpg|gif|png)$/i.test(url);

  const fetchImageAsBase64 = async (url) => {
    const response = await fetch(url);

    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  useEffect(() => {
    fetchImageAsBase64(logoRaiar).then(setImageBase64);
  }, []);

  useEffect(() => {
    if (anexos && anexos.length > 0) {
      const loadImagesParallel = async () => {
        const loadedAnexos = await Promise.all(
          anexos.map(async (anexo) => {
            if (isImageUrl(anexo.caminhoAnexo)) {
              const base64Image = await fetchImageAsBase64(anexo.caminhoAnexo);
              return base64Image ? { ...anexo, base64: base64Image } : null;
            }
            return null;
          })
        );
        setAnexosCarregadosPrint(loadedAnexos.filter(Boolean));
        setAnexosCarregados(true);
      };

      loadImagesParallel();
    }
  }, [anexos]);

  useEffect(() => {
    setTimeout(() => {
      setReady(true);
    }, 1100);
  }, []);

  return (
    ready && (
      <div style={{ width: '100%', height: '100%' }}>
        <PDFViewer style={{ width: "100%", height: "100vh" }}>
          <Document width="100%">
            <CustomPage orientation="landscape" size="A4" style={styles.page} wrap={true}>
              <View style={{ margin: 10 }}>
                <View style={[styles.row]} wrap={false}>
                  {/* Primeira coluna */}
                  <View style={[styles.column, { width: '25%', justifyContent: 'center', alignItems: 'center' }]}>
                    <Image src={imageBase64} style={styles.backgroundImage} />
                  </View>

                  {/* Segunda coluna */}
                  <View style={[styles.column, { width: '25%', justifyContent: 'center', alignItems: 'end', borderRight: 1 }]}>
                    <View style={[styles.cellCabecalho, { borderBottom: 0 }]}>
                      <Text>Diário de Obra</Text>
                    </View>
                  </View>

                  {/* Terceira coluna */}
                  <View style={[styles.column, { width: '50%' }]}>
                    {/* Cabeçalho */}
                    <View style={[styles.cellCabecalho, { backgroundColor: '#d6d4d4' }]}>
                      <Text>Dados</Text>
                    </View>

                    {/* Linha 1 - Cliente */}
                    <View style={styles.cellRow}>
                      <Text style={[styles.cellLabel, { backgroundColor: '#EBEBEB' }]}>Cliente</Text>
                      <Text style={styles.cellValue}>{obraDiario?.obra?.orgao?.nome}</Text>
                    </View>

                    {/* Linha 2 - Obra */}
                    <View style={styles.cellRow}>
                      <Text style={[styles.cellLabel, { backgroundColor: '#EBEBEB' }]}>Obra</Text>
                      <Text style={styles.cellValue}>{obraDiario?.obra?.titulo}</Text>
                    </View>

                    {/* Linha 3 - Local */}
                    <View style={styles.cellRow}>
                      <Text style={[styles.cellLabel, { backgroundColor: '#EBEBEB' }]}>Local</Text>
                      <Text style={styles.cellValue}>{obraDiario.obra.endereco || '-'}</Text>
                    </View>

                    {/* Linha 4 - Data */}
                    <View style={styles.cellLastRow}>
                      <Text style={[styles.cellLabel, { backgroundColor: '#EBEBEB' }]}>Data</Text>
                      <Text style={styles.cellValue}>{moment(obraDiario?.data).format("DD/MM/YYYY")}</Text>
                    </View>
                  </View>
                </View>

                {/* Tempo e equipe */}
                <View style={[styles.cellLastCabecalho, { backgroundColor: '#d6d4d4', borderRight: 1, borderLeft: 1 }]}>
                  <Text>Tempo/Equipe</Text>
                </View>

                {/* Início da tabela de tempo e equipe */}
                <View style={[styles.row]}>
                  {/* Primeira coluna */}
                  <View style={[styles.column, { width: '25%', backgroundColor: '#d6d4d4', justifyContent: 'center', alignItems: 'center', borderRight: 1 }]}>
                    <View style={[styles.cellLastCabecalho]}>
                      <Text>Tempo</Text>
                    </View>
                  </View>
                  {/* Segunda coluna */}
                  <View style={[styles.column, { width: '75%', justifyContent: 'center', alignItems: 'end' }]}>
                    <View style={[styles.cellLastCabecalho, { backgroundColor: '#d6d4d4' }]}>
                      <Text>Equipe</Text>
                    </View>
                  </View>
                </View>
                <View style={[styles.row]}>
                  <View style={[styles.column, { width: '25%', justifyContent: 'center', alignItems: 'center', borderRight: 1 }]}>
                    <View style={[styles.cellLastCabecalho]}>
                      <Text>{obraDiario?.condicaoClimatica == OBRA_DIARIO_CONDICAO_CLIMATICA.SOL ? 'SOL' :
                        obraDiario?.condicaoClimatica == OBRA_DIARIO_CONDICAO_CLIMATICA.NUBLADO ? 'NUBLADO' :
                          'CHUVA'}</Text>
                    </View>
                  </View>
                  <View style={[styles.column, { width: '37.5%', justifyContent: 'center', alignItems: 'end' }]}>
                    <View style={[styles.cellLastCabecalho, { borderRight: 1, backgroundColor: '#EBEBEB' }]}>
                      <Text>Cargo</Text>
                    </View>
                  </View>
                  <View style={[styles.column, { width: '37.5%', justifyContent: 'center', alignItems: 'end' }]}>
                    <View style={[styles.cellLastCabecalho, { backgroundColor: '#EBEBEB' }]}>
                      <Text>Nome</Text>
                    </View>
                  </View>
                </View>
                {equipes && equipes.length > 0 ? equipes?.map((equipe, index) => (
                  <View key={equipe.id} style={[styles.row]}>
                    <View style={[styles.column, { width: '25%', justifyContent: 'center', alignItems: 'center', borderRight: 1 }]}>
                      <View style={[styles.cellLastCabecalho]}>
                        <Text></Text>
                      </View>
                    </View>
                    <View style={[styles.column, { width: '37.5%', justifyContent: 'center', alignItems: 'center', borderRight: 1 }]}>
                      <View style={[styles.cellLastCabecalhoAlignLeft]}>
                        <Text>{equipe?.cargo}</Text>
                      </View>
                    </View>
                    <View style={[styles.column, { width: '37.5%', justifyContent: 'center', alignItems: 'end' }]}>
                      <View style={[styles.cellLastCabecalho]}>
                        <Text>{equipe?.usuario}</Text>
                      </View>
                    </View>
                  </View>
                )) :
                  <View key={`nenhuma-equipe`} style={[styles.row]}>
                    <View style={[styles.column, { width: '100%', justifyContent: 'center', alignItems: 'center', borderRight: 1 }]}>
                      <View style={[styles.cellLastCabecalho]}>
                        <Text>Nenhum registro para ser exibido</Text>
                      </View>
                    </View>
                  </View>
                }
                <View style={[styles.row]}>
                  <View style={[styles.column, { width: '25%', justifyContent: 'center', alignItems: 'center', borderRight: 1 }]}>
                    <View style={[styles.cellLastCabecalhoAlignLeft]}>
                      <Text>Prazo: {obraDiario?.obra?.obrasOrcamentos[0]?.diasPrazo} dias</Text>
                    </View>
                  </View>
                </View>
                <View style={[styles.row]}>
                  <View style={[styles.column, { width: '25%', justifyContent: 'center', alignItems: 'center', borderRight: 1 }]}>
                    <View style={[styles.cellLastCabecalhoAlignLeft]}>
                      <Text>Início: {moment(obraDiario.obra.dataInicio).format("DD/MM/YYYY")}</Text>
                    </View>
                  </View>
                </View>
                <View style={[styles.row]}>
                  <View style={[styles.column, { width: '25%', justifyContent: 'center', alignItems: 'center', borderRight: 1 }]}>
                    <View style={[styles.cellLastCabecalhoAlignLeft]}>
                      <Text>Término: {moment(obraDiario.obra.dataTermino).format("DD/MM/YYYY")}</Text>
                    </View>
                  </View>
                </View>
                <View style={[styles.row, { justifyContent: 'center', alignItems: 'center', backgroundColor: '#EBEBEB' }]}>
                  <View style={[styles.cellLastCabecalho]}>
                    <Text>Registros (observações)</Text>
                  </View>
                </View>
                <View style={[styles.row, { justifyContent: 'center', alignItems: 'center' }]}>
                  <View style={[styles.cellLastCabecalhoAlignLeft]}>
                    <Text>{obraDiario?.observacoes}</Text>
                  </View>
                </View>

                {/* Fotos */}
                <View wrap={false}>
                  <View style={[styles.row, { justifyContent: 'center', alignItems: 'center', backgroundColor: '#EBEBEB', marginTop: 5 }]}>
                    <View style={[styles.cellLastCabecalho]}>
                      <Text>Fotos/Croqui</Text>
                    </View>
                  </View>
                  {/* Só imprime anexos que forem em formato de imagem*/}
                  <View style={[styles.row, { justifyContent: 'center', alignItems: 'center' }]}>
                    <View wrap={false} style={[styles.content, { flex: 1, borderRightWidth: 1, borderRightColor: '#000', borderRightStyle: 'solid' }]}>
                      {anexosCarregados && anexosCarregadosPrint && anexosCarregadosPrint.length > 0 ?
                        <View style={{ flexDirection: 'row', flexWrap: 'wrap', padding: 5 }}>
                          {anexosCarregadosPrint.map((n, index) => {
                            return (
                              n.base64 ? (
                                <Image key={n.id} src={n.base64} style={[styles.imageAnexo, { margin: 5 }]} wrap={false} />
                              ) : (
                                <Text key={index}>Imagem não disponível</Text>
                              )
                            )
                          })}
                        </View> :
                        <View style={[styles.cellLastCabecalho]}>
                          <Text>Nenhum anexo para ser exibido</Text>
                        </View>
                      }
                    </View>
                  </View>
                </View>
                <ObraDiarioPrintPdfFooter
                  responsavelTecnico={obraDiario.responsavelTecnico}
                  data={obraDiario.data}
                />
              </View>
            </CustomPage>
          </Document>
        </PDFViewer >
      </div >
    )
  );
};

const mapStateToProps = (state) => {
  return state;
};

const connectedObraDiarioPrintPdfPage = withRouter(connect(mapStateToProps, null, null)(ObraDiarioPrintPdf));
export { connectedObraDiarioPrintPdfPage as ObraDiarioPrintPdf };
